import { get, withUrl, Request } from '@factorin/rest';


export type DocsGroups = 'ip' | 'company' | 'general' | 'flPartner';

export interface QueryGroupsOfDocs{
    group: DocsGroups;
}

export interface Document {
    id: string;
    type: string;
    file: {
        url: string;
    } | null;
    header: string;
    order: number;
    checklist: boolean;
}

export type DocumentsIds = Array<string>;

const documentsPart = withUrl('Docs');

export const documents = {
    list: get<Request.Query<QueryGroupsOfDocs>, Document[]>(({ query }) => documentsPart({ path: 'list', query })),
};
